if (!customElements.get('product-bundle')) {
  customElements.define(
    'product-bundle',
    class ProductBundle extends HTMLElement {
      constructor() {
        super();
        this.sectionId = this.dataset.sectionId;
        this.basePrice = parseInt(this.dataset.basePrice, 10) || 0;
        this.moneyFormat = this.dataset.moneyFormat || '{{amount}}';
      }

      connectedCallback() {
        this.addEventListener('change', (event) => {
          if (event.target.matches('[data-variant-select]')) {
            this.onVariantSelectChange(event);
          } else if (event.target.matches('.product-bundle__item-checkbox')) {
            this.updateTotal();
          }
        });

        this.submitButton = this.querySelector('[data-bundle-submit]');
        this.onSubmit = this.onSubmit.bind(this);
        this.submitButton?.addEventListener('click', this.onSubmit);

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (payload) => {
            if (String(payload.data.sectionId) !== String(this.sectionId)) return;
            this.basePrice = payload.data.variant ? payload.data.variant.price : 0;
            this.updateTotal();
          });
        }

        this.updateTotal();
      }

      disconnectedCallback() {
        this.variantChangeUnsubscriber?.();
      }

      onVariantSelectChange(event) {
        const select = event.target;
        const row = select.closest('.product-bundle__item');
        const checkbox = row?.querySelector('.product-bundle__item-checkbox');
        const option = select.options[select.selectedIndex];
        if (checkbox && option) {
          checkbox.dataset.variantId = option.value;
          checkbox.dataset.price = option.dataset.price;
          const priceEl = row.querySelector('.product-bundle__item-price');
          if (priceEl) priceEl.textContent = this.formatMoney(option.dataset.price);
        }
        this.updateTotal();
      }

      getCheckedItems() {
        return Array.from(this.querySelectorAll('.product-bundle__item-checkbox:checked'));
      }

      updateTotal() {
        const itemsTotal = this.getCheckedItems().reduce(
          (sum, checkbox) => sum + (parseInt(checkbox.dataset.price, 10) || 0),
          0
        );
        const totalEl = this.querySelector('[data-bundle-total]');
        if (totalEl) totalEl.textContent = this.formatMoney(this.basePrice + itemsTotal);
      }

      formatMoney(cents) {
        cents = parseInt(cents, 10) || 0;
        const amount = (cents / 100).toFixed(2);
        const parts = amount.split('.');
        const grouped = (separator) => parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, separator);

        return this.moneyFormat
          .replace(/\{\{\s*amount\s*\}\}/, `${grouped(',')}.${parts[1]}`)
          .replace(/\{\{\s*amount_no_decimals\s*\}\}/, grouped(','))
          .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, `${grouped('.')},${parts[1]}`)
          .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, grouped('.'));
      }

      getMainVariantInput() {
        return document.querySelector(`#product-form-${this.sectionId} [name="id"]`);
      }

      getMainQuantity() {
        const quantityInput = document.getElementById(`Quantity-${this.sectionId}`);
        return quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;
      }

      onSubmit(event) {
        event.preventDefault();
        if (this.submitButton.hasAttribute('disabled')) return;

        const mainVariantInput = this.getMainVariantInput();
        if (!mainVariantInput || !mainVariantInput.value) return;

        const items = [{ id: parseInt(mainVariantInput.value, 10), quantity: this.getMainQuantity() }];

        this.getCheckedItems().forEach((checkbox) => {
          const variantId = parseInt(checkbox.dataset.variantId, 10);
          if (variantId) items.push({ id: variantId, quantity: 1 });
        });

        this.submitButton.setAttribute('disabled', 'disabled');
        this.submitButton.classList.add('loading');

        fetch(window.routes.cart_add_url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items }),
        })
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              throw new Error(response.description || 'Unable to add items to cart');
            }
            window.location.href = window.routes.cart_url;
          })
          .catch(() => {
            this.submitButton.removeAttribute('disabled');
            this.submitButton.classList.remove('loading');
          });
      }
    }
  );
}
